<template>
  <a-layout v-if="menuData.length >0">
    <sider-menu
      :theme="theme"
      v-if="layout === 'side'"
      :menuData="menuData"
      :collapsed="collapsed"
      :collapsible="true"
    />
    <a-layout>
      <global-header :menuData="menuData" :collapsed="collapsed"/>
      <a-layout-content style="flex: 1;width: 80%;margin-left: 10%;">
        <slot></slot>
      </a-layout-content>
      <a-layout-footer style="padding: 12px 0">
        <global-footer :link-list="linkList" :copyright="copyright"/>
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import GlobalHeader from './GlobalHeader'
import GlobalFooter from './GlobalFooter'
import SiderMenu from '../components/menu/SiderMenu'

let menuData = [];
const minHeight = window.innerHeight - 115
export default {
  name: 'GlobalLayout',
  components: {SiderMenu, GlobalFooter, GlobalHeader},
  data() {
    return {
      minHeight: minHeight + 'px',
      collapsed: false,
      menuData: menuData,
      showSetting: false
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.setting.isMobile
    },
    theme() {
      return this.$store.state.setting.theme
    },
    layout() {
      return this.$store.state.setting.layout
    },
    linkList() {
      return this.$store.state.setting.footerLinks
    },
    copyright() {
      return this.$store.state.setting.copyright
    }
  },
  methods: {
    toggleCollapse() {
      //this.collapsed = !this.collapsed
      // this.triggerWindowResizeEvent()
    },
    onDrawerChange(show) {
      this.collapsed = show
    },
    onMenuSelect() {
      this.toggleCollapse()
    },
    onSettingDrawerChange(val) {
      this.showSetting = val
    },
    triggerWindowResizeEvent() {
      const event = document.createEvent('HTMLEvents')
      event.initEvent('resize', true, true)
      event.eventType = 'message'
      window.dispatchEvent(event)
    },
    _browserRedirect() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) || false
      let bIsIphoneOs = sUserAgent.match(/iphone/i) || false
      let bIsMidp = sUserAgent.match(/midp/i) || false
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) || false
      let bIsUc = sUserAgent.match(/ucweb/i) || false
      let bIsAndroid = sUserAgent.match(/android/i) || false
      let bIsCE = sUserAgent.match(/windows ce/i) || false
      let bIsWM = sUserAgent.match(/windows mobile/i) || false
      if (bIsIpad[0] || bIsIphoneOs[0] || bIsMidp[0] || bIsUc7[0] || bIsUc[0] || bIsAndroid[0] || bIsCE[0] || bIsWM[0]) {
        /* 当前是手机端*/
        alert('手机端访问');
      } else {
        /* 当前是PC端*/
        alert('PC端访问');
      }
    }
    // getMenu () {
    //   console.log(2, 'getMenu')
    //   let menuList = this.$store.state.setting.MenuList
    //   console.log(menuList, 'menuList')
    //   if (menuList.length === 0) {
    //     this.$message.error(
    //       '您没有访问菜单权限，请联系管理员添加！'
    //     )
    //     return
    //   }
    //   let routers = this.$router.options.routes.find((item) => item.path === '/').children
    //   routers.forEach(router => {
    //     router.children.forEach(item => {
    //       item.invisible = true
    //       let url = item.path.split('/')[item.path.split('/').length - 1]
    //       let menus = menuList.filter(menu => menu.ActionUrl === url)
    //       if (menus.length > 0) {
    //         item.invisible = false
    //         if (menus[0].iconUrl) {
    //           item.icon = menus[0].iconUrl
    //         }
    //         //item.sort = menus[0].sort;
    //         //let parentMenu = menuList.find(menu =>menu.menuId === menus[0].parentMenuId)
    //         //router.sort = parentMenu? parentMenu.sort: menus[0].sort;
    //         return
    //       }
    //     })
    //     //router.children = router.children?router.children.sort((p,q) => q.sort -p.sort): '';
    //     router.invisible =
    //       router.children.filter(item => item.invisible).length === router.children.length
    //   })
    //   this.menuData = routers
    //   console.log(this.menuData, 'menuData')
    // },
    // getUrlParam(name) {
    //   let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    //   let r = window.location.search.substr(1).match(reg);
    //   console.log(r);
    //   if (r != null) return unescape(r[2]);
    //   return null;
    // },
  },
  beforeCreate() {
    let menuList = this.$store.state.setting.MenuList.userMenuDtos;
    // if(!menuList) {
    //   this.$message.error('您没有访问菜单权限，请联系管理员添加！');
    //   this.$router.push('/login');
    //   return;
    // }
    // if (menuList.length === 0) {
    //   this.$message.error(
    //     '您没有访问菜单权限，请联系管理员添加！'
    //   )
    //   this.$router.push('/login');
    //   return
    // }
    let routers = this.$router.options.routes.find((item) => item.path === '/').children;
    // routers.forEach(router => {
      // router.children.forEach(item => {
        // item.invisible = true;
        // let url = item.path.split('/')[item.path.split('/').length - 1];
        // let menus = menuList.filter(menu => menu.actionUrl === url);
        // if (menus.length > 0) {
          // item.invisible = false;
          // if (menus[0].iconUrl) {
          //   item.icon = menus[0].iconUrl;
          // }
          // item.sort = menus[0].sort;
          // let parentMenu = menuList.find(menu =>menu.menuId === menus[0].parentMenuId)
          // router.sort = parentMenu? parentMenu.sort: menus[0].sort;
          // return;
        // }
      // })
      // router.children = router.children?router.children.sort((p,q) => q.sort -p.sort): '';
      // router.invisible =
      //   router.children.filter(item => item.invisible).length === router.children.length
    // })
    menuData = routers.sort((p, q) => q.sort - p.sort)
  },
}
</script>

<style lang="less" scoped>
.setting {
  background-color: #1890ff;
  color: #fff;
  border-radius: 5px 0 0 5px;
  line-height: 40px;
  font-size: 22px;
  width: 40px;
  height: 40px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/layouts/GlobalLayout.vue